<template>
  <v-select
    :id="inputId"
    :items="items"
    v-model="inputValue"
    @keydown.tab.exact.prevent="handleTabPress"
    @keydown.shift.tab.prevent="handleShiftTabPress"
    :dense="dense"
  ></v-select>
</template>

<script lang="ts">
  import Vue from 'vue';
  import { mixins } from '@/mixin/mixins';

  export default Vue.extend({
    name: 'Indicator',
    mixins: [mixins],
    props: {
      value: {
        type: String,
        default: '',
      },
      id: {
        type: String,
        default: '',
      },
      nextElementId: {
        type: String,
        default: '',
      },
      prevElementId: {
        type: String,
        default: '',
      },
      dense: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        inputValue: this.value?.toLocaleUpperCase() === 'H' ? 'Vs' : 'At',
        items: ['Vs', 'At'],
        inputId: this.id,
      };
    },
    watch: {
      inputValue(newVal: string) {
        this.$emit('input', newVal === 'Vs' ? 'H' : 'A');
      },
    },
    methods: {
      handleTabPress() {
        this.triggerEnterKeyPressEvent(this.inputId);
        this.clickElementbyId(this.nextElementId);
      },
      handleShiftTabPress() {
        this.triggerEnterKeyPressEvent(this.inputId);
        this.clickElementbyId(this.prevElementId);
      },
    },
  });
</script>
